import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { playersResponseSchema } from '../types';

export const receivePlayers = createReceive('players', zodContract(playersResponseSchema));
